import { Button, Tooltip } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import { AddCircleOutline as AddCircleOutlineIcon } from "@mui/icons-material";
import React from "react";
import { useTranslation } from "react-i18next";

import { NewRecord as INewRecord } from "../../export";
import { getBrandCustom } from "../../utils/getCustomColor";

type Props = {
  newRecord?: INewRecord;
};

const ButtonCustomized = withStyles(() => ({
  root: {
    backgroundColor: getBrandCustom("primaryColor", "#38CFC4"),
    color: "#FFFFFF",
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    lineHeight: "15px",
    height: "40px",
    borderRadius: "8px",
    fontWeight: 700,
    textTransform: "none",
    whiteSpace: "nowrap",
    padding: "10px",
    "& .MuiButton-startIcon": {
      marginLeft: 0,
    },
    "&:hover": {
      backgroundColor: getBrandCustom("hoverColor", "#3FE3D7"),
    },
  },
}))(Button);

const NewRecord = (props: Props) => {
  const { newRecord, ...rest } = props;
  const { t: translate } = useTranslation();

  return (
    <Tooltip id="btn-new-tool" placement="top" title={newRecord?.tooltip || translate("addNew")} {...rest}>
      <ButtonCustomized
        disableElevation
        variant="contained"
        startIcon={<AddCircleOutlineIcon htmlColor="#FFFFFF" />}
        onClick={() => {
          if (newRecord && newRecord?.action) newRecord?.action();
        }}
      >
        {newRecord?.text || translate("create")}
      </ButtonCustomized>
    </Tooltip>
  );
};

export default NewRecord;
